const GA_TRACKING_ID = 'UA-138147486-3'
const EXTERNAL_TRACK_KEYS = [
  { label: 'Google Analytics', value: 'gtag' },
  { label: 'Facebook Analytics', value: 'fbq' },
]
export { GA_TRACKING_ID, EXTERNAL_TRACK_KEYS }
